/**
 * CACHET DE CIRE - Animations & Icons
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Initialize Lucide Icons
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  }
  
  // Reveal animations on scroll
  const revealElements = document.querySelectorAll('.cachet-reveal');
  
  const revealOnScroll = function() {
    const windowHeight = window.innerHeight;
    
    revealElements.forEach(function(el) {
      const elementTop = el.getBoundingClientRect().top;
      
      if (elementTop < windowHeight - 80) {
        el.classList.add('active');
      }
    });
  };
  
  // Run on load
  revealOnScroll();
  
  // Run on scroll (throttled)
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        revealOnScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
  
});

// Re-init Lucide after Shopify section reload
document.addEventListener('shopify:section:load', function() {
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  }
});
